<template>
  <Loader v-if="loading"></Loader>
  <div>
    <!-- Upload Sections Container -->
    <div class="flex justify-content-center align-items-center h-6rem">
      <h1>SWITCH OUT</h1>
    </div>
    <div class="upload-sections-container">
      <!-- POD Section -->
      <!-- <div class="upload-section pod-section">
        <Card class="upload-card">
          <template v-slot:header>
            <div class="card-header">
              <i class="pi pi-bolt header-icon"></i>
              <h1 class="header-title">Switch Out POD</h1>
            </div>
          </template>
          <template v-slot:content>
            <div class="upload-content">
              <div class="upload-zone"> 
                <div class="button-wrapper"> 
                  <span class="label">{{
                    podFileToUpload.length == 0
                      ? "Seleziona File"
                      : podFileToUpload.length + " files"
                  }}</span>
                  <input type="file" ref="podFileInputRef" @change="handlePodFileUpload" accept=".csv" multiple
                    class="upload-input" />
                </div>
              </div>
              <div v-if="podFileToUpload.length > 0" class="file-preview-container">
                <h3>Anteprima File</h3>
                <ul class="file-preview-list">
                  <li v-for="(file, index) in podFileToUpload" :key="index" class="file-preview-item">
                    <i class="pi pi-file file-icon"></i>
                    <span class="file-name">{{ file.name }}</span>
                    <button @click.prevent="removeFile('POD', index)" class="remove-button">
                      <i class="pi pi-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div class="action-buttons">
                <Button @click="uploadPodFiles" class="p-button-primary upload-button">
                  <i class="pi pi-upload"></i>
                  <span>Carica File</span>
                </Button>
              </div>
            </div>
          </template>
        </Card>
      </div> -->

      <!-- PDR Section -->
      <!-- <div class="upload-section pdr-section">
        <Card class="upload-card">
          <template v-slot:header>
            <div class="card-header">
              <i class="pi pi-fire header-icon"></i>
              <h1 class="header-title">Switch Out PDR</h1>
            </div>
          </template>
          <template v-slot:content>
            <div class="upload-content">
              <div class="upload-zone"> 
                <div class="button-wrapper">
                  <span class="label">{{
                    pdrFileToUpload.length == 0
                      ? "Seleziona File"
                      : pdrFileToUpload.length + " files"
                  }}</span>
                  <input type="file" ref="pdrFileInputRef" @change="handlePdrFileUpload" accept=".csv" multiple
                    class="upload-input" />
                </div>
              </div>
              <div v-if="pdrFileToUpload.length > 0" class="file-preview-container">
                <h3>Anteprima File</h3>
                <ul class="file-preview-list">
                  <li v-for="(file, index) in pdrFileToUpload" :key="index" class="file-preview-item">
                    <i class="pi pi-file file-icon"></i>
                    <span class="file-name">{{ file.name }}</span>
                    <button @click.prevent="removeFile('PDR', index)" class="remove-button">
                      <i class="pi pi-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div class="action-buttons">
                <Button @click="uploadPdrFiles" class="p-button-primary upload-button">
                  <i class="pi pi-upload"></i>
                  <span>Carica File</span>
                </Button>
              </div>
            </div>
          </template>
        </Card>
      </div> -->
    </div>

    <!-- Unified Sync Button -->
    <!-- <div class="sync-container">
      <Button @click="updatePodFiles(); updatePdrFiles();" class="p-button-secondary sync-button">
        <i class="pi pi-sync"></i>
        <span class="sync-text">Sincronizza</span>
      </Button>
    </div> -->
    <!-- History Section -->

    <div class="sync-container">

      <Button @click="sendTestEmail();" class="p-button-secondary sync-button mr-3">
        <i class="pi pi-sync"></i>
        <span class="sync-text">E-Mail Interna</span>
      </Button>

      <Button @click="sendOfficialEmail()" :disabled="disableOfficialMail" class="p-button-secondary sync-button">
        <i class="pi pi-sync"></i>
        <span class="sync-text">E-Mail Ufficiale</span>
      </Button>
      
    </div>

    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br />
          <h3 class="page-title">Storico File Caricati</h3>
          <div class="filter-buttons-SwitchOut">
            <SelectButton v-model="selectedFilter" :options="filterOptions" @update:modelValue="handleFilterChange"
              aria-labelledby="filter-type" :allowEmpty="false" optionLabel="name" optionValue="code" />
          </div>
        </template>
        <template v-slot:content>
          <div>
            <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="file-search-input" />
          </div>
          <table class="file-table">
            <thead>
              <tr>
                <th>File</th>
                <th>Data di caricamento</th>
                <th>Tipologia</th>
                <th>Utente</th>
                <th>Scarica</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in uploadedFiles" :key="file.file_name">
                <td>{{ file.file_name }}</td>
                <td>{{ file.created_at }}</td>
                <td>{{ file.name_fornitore }}</td>
                <td>
                  <span class="email">{{ file.email }}</span>
                </td>
                <td>
                  <button @click.stop.prevent="handleFileDownload(file.file_name, file.name_fornitore)"
                    class="download-button">
                    <i class="pi pi-download"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="file-count-select-wrapper">
            <select id="fileCount" v-model="filesPerPage" class="file-count-select">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </template>
      </Card>
    </div>

    <!-- Log History Section -->
    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br>
          <h3 class="page-title">Storico Elaborazione File</h3>
        </template>
        <template v-slot:content>
  <table class="file-table">
    <thead>
      <tr>
        <th>Id</th>
        <th>operation</th>
        <th>created_at</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in logMessages" :key="item.id">
        <td>{{ item.id }}</td>
        <td>{{ item.operation }}</td>
        <td>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
      </tr>
    </tbody>
  </table>
</template>
      </Card>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import { useStore } from "vuex";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import SelectButton from 'primevue/selectbutton';
import { useConfirm } from 'primevue/useconfirm';

export default {
  components: {
    Loader,
    SelectButton
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);

    // Separate refs for POD and PDR files
    const podFileToUpload = ref([]);
    const pdrFileToUpload = ref([]);
    const podFileContent = ref('');
    const pdrFileContent = ref('');
    const podFileInputRef = ref(null);
    const pdrFileInputRef = ref(null);
    const currentUser = ref(store.state.auth.user);
    const allowedType = ["csv"];
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const uploadedFiles = ref([]);
    const currentPage = ref(1);
    const filesPerPage = ref(10);
    const searchQuery = ref("");
    const originalUploadedFiles = ref([]);
    const logMessages = ref([]);
    const selectedFilter = ref('POD');
    const filterOptions = ref([
      { name: 'POD', code: 'POD' },
      { name: 'PDR', code: 'PDR' }
    ]);

    const disableOfficialMail = ref(false);

    // POD File Handling
    const handlePodFileUpload = async (evt) => {
  evt.preventDefault();
  submitted.value = false;

  const filesInput = evt.target;
  const files = filesInput.files;

  if (!files || files.length === 0) {
    toast.add({
      severity: "error",
      summary: "Errore",
      detail: "Nessun file selezionato"
    });
    return;
  }

  const validFiles = [];
  const maxSize = 500000 * 1024;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    if (file.size > maxSize) {
      toast.add({
        severity: "error",
        summary: "Errore",
        detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`
      });
      continue;
    }

    if (!file.name.startsWith("Comunicazione esecuzione SwitchOUT")) {
      toast.add({
        severity: "error",
        summary: "Errore",
        detail: `Il file ${file.name} non è un file POD valido`
      });
      continue;
    }

    validFiles.push(file);

    // Read file content
    const reader = new FileReader();
    reader.onload = (e) => {
      podFileContent.value = e.target.result;
    };
    reader.onerror = () => {
      toast.add({
        severity: "error",
        summary: "Errore",
        detail: `Errore durante la lettura del file ${file.name}`
      });
    };
    reader.readAsText(file);
  }

  podFileToUpload.value = validFiles;
};

    // Handle file drop for POD
    const handlePodDrop = (event) => {
      event.preventDefault();
      const droppedFiles = Array.from(event.dataTransfer.files);
      const validFiles = droppedFiles.filter(file => {
        return file.name.startsWith("Comunicazione esecuzione SwitchOUT");
      });

      if (validFiles.length > 0) {
        podFileToUpload.value = validFiles;
      } else {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "I file devono iniziare con 'Comunicazione esecuzione SwitchOUT'"
        });
      }
    };

    // Handle file drop for PDR
    const handlePdrDrop = (event) => {
      event.preventDefault();
      const droppedFiles = Array.from(event.dataTransfer.files);
      const validFiles = droppedFiles.filter(file => {
        return file.name.startsWith("Comunicazione Recesso Gas");
      });

      if (validFiles.length > 0) {
        pdrFileToUpload.value = validFiles;
      } else {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "I file devono iniziare con 'Comunicazione Recesso Gas'"
        });
      }
    };

    // PDR File Handling
    const handlePdrFileUpload = async (evt) => {
  evt.preventDefault();
  submitted.value = false;

  const filesInput = evt.target;
  const files = filesInput.files;

  if (!files || files.length === 0) {
    toast.add({
      severity: "error",
      summary: "Errore",
      detail: "Nessun file selezionato"
    });
    return;
  }

  const validFiles = [];
  const maxSize = 500000 * 1024;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    if (file.size > maxSize) {
      toast.add({
        severity: "error",
        summary: "Errore",
        detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`
      });
      continue;
    }

    if (!file.name.startsWith("Comunicazione Recesso Gas")) {
      toast.add({
        severity: "error",
        summary: "Errore",
        detail: `Il file ${file.name} non è un file PDR valido`
      });
      continue;
    }

    validFiles.push(file);

    // Read file content
    const reader = new FileReader();
    reader.onload = (e) => {
      pdrFileContent.value = e.target.result;
    };
    reader.onerror = () => {
      toast.add({
        severity: "error",
        summary: "Errore",
        detail: `Errore durante la lettura del file ${file.name}`
      });
    };
    reader.readAsText(file);
  }

  pdrFileToUpload.value = validFiles;
};

    const removeFile = (type, index) => {
      if (type === 'POD') {
        const updatedFiles = [...podFileToUpload.value];
        updatedFiles.splice(index, 1);
        podFileToUpload.value = updatedFiles;

        // Reset input se non ci sono più file
        if (updatedFiles.length === 0) {
          podFileContent.value = '';
          if (podFileInputRef.value) {
            podFileInputRef.value = '';
          }
        }
      } else if (type === 'PDR') {
        const updatedFiles = [...pdrFileToUpload.value];
        updatedFiles.splice(index, 1);
        pdrFileToUpload.value = updatedFiles;

        // Reset input se non ci sono più file
        if (updatedFiles.length === 0) {
          pdrFileContent.value = '';
          if (pdrFileInputRef.value) {
            pdrFileInputRef.value = '';
          }
        }
      }
    };
    const uploadPodFiles = () => {
      submitted.value = true;
      if (validatePodForm()) {
        uploadFiles(podFileToUpload.value, "POD");
      }
    };

    const uploadPdrFiles = () => {
      submitted.value = true;
      if (validatePdrForm()) {
        uploadFiles(pdrFileToUpload.value, "PDR");
      }
    };

    const uploadFiles = (files, type) => {
      loading.value = true;

      service
        .uploadFileSwitchOutOnFtp(files, type)
        .then((response) => {
          // const uploaded = response.files;

          // uploaded.forEach((file) => {
          //   file.uploader = currentUser.value;
          // });

          // uploadedFiles.value = [...uploadedFiles.value, ...uploaded];
          uploadedFiles.value = [...uploadedFiles.value];

          const message = response.message || "File Caricati con successo";
          toast.add({
            severity: "success",
            summary: "Successo",
            detail: message
          });
          fetchUploadedFiles();

          if (type === "POD") {
            podFileToUpload.value = [];
            podFileContent.value = '';
            if (podFileInputRef.value) podFileInputRef.value.value = "";
          } else {
            pdrFileToUpload.value = [];
            pdrFileContent.value = '';
            if (pdrFileInputRef.value) pdrFileInputRef.value.value = "";
          }
        })
        .catch((error) => {
          console.log("Errore durante il caricamento dei file", error);
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore durante il caricamento dei file"
          });
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const updatePodFiles = () => updateFiles("POD");
    const updatePdrFiles = () => updateFiles("PDR");


    const updateFiles = async (type) => {
      loading.value = true;
      try {
        const result = await service.updateFileDossier("switch-out");
        if (result && result.items.success) {
          toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Aggiornamento file completato"
          });
        } else {
          toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "Nessun file aggiornato"
          });
        }
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'aggiornamento dei file"
        });
      } finally {
        loading.value = false;
      }
    };


    const validatePodForm = () => {
      if (podFileToUpload.value.length == 0) {
        validationErrors.value["podFiles"] = true;
        delete validationErrors.value["podType"];
      } else {
        delete validationErrors.value["podFiles"];
      }

      if (podFileToUpload.value.length > 0) {
        let valid = [...podFileToUpload.value].every(
          (file) => allowedType.includes(file.type.replace(/(.*)\//g, "")),
          false
        );
        if (valid) delete validationErrors.value["podType"];
        else validationErrors.value["podType"] = true;
      }

      return !Object.keys(validationErrors.value).length;
    };

    const validatePdrForm = () => {
      if (pdrFileToUpload.value.length == 0) {
        validationErrors.value["pdrFiles"] = true;
        delete validationErrors.value["pdrType"];
      } else {
        delete validationErrors.value["pdrFiles"];
      }
      if (pdrFileToUpload.value.length > 0) {
        let valid = [...pdrFileToUpload.value].every(
          (file) => allowedType.includes(file.type.replace(/(.*)\//g, "")),
          false
        );
        if (valid) delete validationErrors.value["pdrType"];
        else validationErrors.value["pdrType"] = true;
      }

      return !Object.keys(validationErrors.value).length;
    };

    const getLogsFileElaborazioneAskFileSwitchOut = async () => {
      loading.value = true;

      service
        .getLogsFileElaborazioneAskFile("process-switch-out")
        .then((res) => {
          logMessages.value = res.items;
        })
        .catch((err) => { })
        .finally(() => {
          loading.value = false;
        });
    };

    const fetchUploadedFiles = async () => {
      try {
        const filesResponse = await service.getAllUploadedFilesSwitchOut();
        const formattedFiles = filesResponse.map((file) => {
          return {
            ...file,
            created_at: moment(file.created_at).format("YYYY-MM-DD HH:mm:ss"),
          };
        });
        uploadedFiles.value = formattedFiles;
        originalUploadedFiles.value = formattedFiles;

        // Apply initial filter if one is selected
        if (selectedFilter.value) {
          filterBySubdirectory(selectedFilter.value);
        }
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dei file"
        });
      }
    };

    const handleFilterChange = (event) => {
      selectedFilter.value = event;
      filterBySubdirectory(selectedFilter.value);
    };

    const filterBySubdirectory = (subdirectory) => {
      if (subdirectory) {
        uploadedFiles.value = originalUploadedFiles.value.filter(
          (file) => file.name_fornitore.trim().toLowerCase() === subdirectory.toLowerCase()
        );
      } else {
        uploadedFiles.value = [...originalUploadedFiles.value];
      }
    };
    const paginatedFiles = computed(() => {
      const startIndex = (currentPage.value - 1) * filesPerPage.value;
      const endIndex = startIndex + filesPerPage.value;
      return uploadedFiles.value.slice(startIndex, endIndex);
    });

    const filteredFiles = computed(() => {
      return uploadedFiles.value.filter((file) => {
        return file.file_name
          .toLowerCase()
          .includes(searchQuery.value.toLowerCase());
      });
    });

    const confirm = useConfirm();

    const confirmSend = (callback) => {
      confirm.require({
        message: 'Sei sicuro di voler inviare l\'email?',
        header: 'Conferma Invio',
        icon: 'pi pi-exclamation-triangle',
        accept: callback,
        reject: () => {
          console.log('Invio email annullato');
        }
      });
    };

    const sendTestEmail = () => {
      console.log('Preparazione invio email di test...');
      confirmSend(() => {
        loading.value = true;

        Promise.all([
          service.generateSwitchoutCacheEE(),
          service.generateSwitchoutCacheGas()
        ])
        .then(() => {
          console.log('Tabelle cache generate');
          return Promise.all([
            service.sendTestSwitchoutEmailEE(),
            service.sendTestSwitchoutEmailGas()
          ]);
        })
        .then(() => {
          console.log('Email di test inviate');
        })
        .catch(err => {
          console.log('Errore:', err);
        })
        .finally(() => {
          loading.value = false;
        });

      });
    };

    const sendOfficialEmail = () => {
      console.log('Preparazione invio email ufficiale...');
      
      confirmSend(() => {
        loading.value = true;

        Promise.all([
          service.generateSwitchoutCacheEE(),
          service.generateSwitchoutCacheGas()
        ])
        .then(() => {
          console.log('Tabelle cache generate');
          return Promise.all([
            service.sendOfficialSwitchoutEmailEE(),
            service.sendOfficialSwitchoutEmailGas()
          ]);
        })
        .then(() => {
          console.log('Email ufficiali inviate');
        })
        .catch(err => {
          console.log('Errore:', err);
        })
        .finally(() => {
          loading.value = false;
        });

      });
    };

    const handleFileDownload = async (filename, supplyType) => {
      try {
        console.log(filename);
        const response = await service.downloadSwitchout(filename, supplyType);

        const blob = new Blob([response.data], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore durante il download:", error);

        let errorMessage = "Errore durante il download del file";
        if (error.response && error.response.status === 404) {
          errorMessage = "File non trovato";
        } else if (error.response && error.response.status === 500) {
          errorMessage = "Errore interno del server";
        }

        toast.add({
          severity: "error",
          summary: "Errore",
          detail: errorMessage,
          life: 3000,
        });
      }
    }

    const checkExistNotElaboratedAccettazione = async () => {
      try {
        const res = await service.existNotElaboratedAccettazione();

        const exists = typeof res === "boolean" ? res : !!res?.exists;

        disableOfficialMail.value = exists;
      } catch (error) {
        console.error("Errore durante la verifica accettazione:", error);

        const message =
          error?.response?.data?.message ||
          error?.response?.data ||
          error?.message ||
          "Errore imprevisto";

        toast.add({
          severity: "error",
          summary: "Errore",
          detail: message,
          life: 3000,
        });
      }
    };

    onMounted(async () => {
      try {
        await fetchUploadedFiles();
        await getLogsFileElaborazioneAskFileSwitchOut();
        await checkExistNotElaboratedAccettazione();
      } catch (error) {
        console.error("Errore durante il caricamento iniziale:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il caricamento iniziale"
        });
      }
    });

    return {
      podFileToUpload,
      pdrFileToUpload,
      podFileContent,
      pdrFileContent,
      podFileInputRef,
      pdrFileInputRef,
      validationErrors,
      submitted,
      loading,
      uploadedFiles,
      currentUser,
      currentPage,
      filesPerPage,
      searchQuery,
      logMessages,
      selectedFilter,
      filterOptions,
      allowedType,
      removeFile,
      // Methods
      handlePodFileUpload,
      handlePdrFileUpload,
      uploadPodFiles,
      uploadPdrFiles,
      updatePodFiles,
      updatePdrFiles,
      handleFilterChange,
      handleFileDownload,
      moment,
      
      // Computed
      paginatedFiles,
      filteredFiles,

      sendTestEmail,
      sendOfficialEmail,
      disableOfficialMail
    };
  },
};
</script>
<style>
:root {
  --primary-color: #3B82F6;
  --success-color: #4CAF50;
  --border-color: #e2e8f0;
  --text-primary: #0f172a;
  --text-secondary: #475569;
  --bg-gradient: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  --card-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

/* Layout and Container styles */
.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
}

.upload-sections-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  max-width: 2000px;
  margin: 0 auto;
}

/* Card and Header styles */
.upload-card {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  transition: transform 0.2s, box-shadow 0.2s;
}

.upload-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px 12px 0 0;
}

.header-icon {
  font-size: 2rem;
  color: #0ea5e9;
}

.header-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

/* Upload zone and button styles */
.upload-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.upload-zone {
  border: 2px dashed var(--border-color);
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: all 0.2s;
}

.upload-zone:hover {
  border-color: var(--primary-color);
  background-color: #f8fafc;
}

.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin: 0 auto;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #63796c !important;
  cursor: pointer;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  box-shadow: 0 10px 13px -7px #00000050;
}

.upload-input,
.file-input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/* File preview styles */

.file-preview-container,
.file-preview {
  margin-top: 1.5rem;
  width: 45em;
  padding: 1.25rem;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background-color: #f8fafc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.file-preview-container{
  font-size: 0.975rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-color);
}

.file-preview-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 240px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--primary-color) #f1f5f9;
}

.file-preview-list::-webkit-scrollbar {
  width: 6px;
}

.file-preview-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.file-preview-list::-webkit-scrollbar-thumb {
  background-color: var(--primary-color);
  border-radius: 3px;
}

.file-preview-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  transition: all 0.2s;
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-preview-item:last-child {
  margin-bottom: 0;
}

.file-preview-item:hover {
  background-color: #f8fafc;
  border-color: var(--border-color);
}

.file-icon {
  font-size: 1.25rem;
  color: var(--primary-color);
  flex-shrink: 0;
}

/* Make PDR preview consistent with POD */
.file-preview p {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.file-preview p:before {
  content: "";
  font-family: "PrimeIcons";
  content: "\e927";
  font-size: 1.25rem;
  color: var(--primary-color);
}

.file-preview p:hover {
  background-color: #f8fafc;
  border-color: var(--primary-color);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.remove-button {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #dc2626;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-preview-item:hover .remove-button {
  opacity: 1;
}

.remove-button:hover {
  background-color: #fee2e2;
}

/* Table styles */
.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th,
.file-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.file-table th {
  background: var(--bg-gradient);
  font-weight: bold;
  color: white;
}

/* Button styles */
.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.upload-button {
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: #1f5d38;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.sync-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 2rem 0;
}

.sync-button {
  width: 200px;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.sync-button i {
  transition: transform 0.5s ease-in-out;
}

.sync-button:active i {
  transform: rotate(360deg);
}

/* Filter and search styles */
.filter-buttons-SwitchOut {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
}

.p-selectbutton {
  display: flex;
  justify-content: center;
  border-radius: 8px;
}

.p-selectbutton .p-button {
  background-color: white;
  font-weight: bold;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 8px;
  color: #414141;
}

.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
  background-color: #1f5d38;
  color: white;
  box-shadow: 0 2px 10px rgba(39, 42, 46, 0.2);
}

.p-selectbutton .p-button.p-highlight {
  background: #1f5d38 !important;
  border-color: #1f5d38;
  color: white;
}

/* Utility classes */
.file-search-input {
  margin-bottom: 10px;
  width: 10%;
  padding: 8px;
  border: 1px solid black;
  border-radius: 5px;
}

.file-count-select-wrapper {
  margin: 20px auto 0;
  width: fit-content;
}

.file-count-select {
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
}

.history-card {
  width: 100%;
  margin-top: 2rem;
}

.page-title {
  font-size: 20px;
  text-align: center;
}

.download-button {
  background-color: transparent;
  margin-left: 15px;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
}

.download-button:hover {
  color: #0056b3;
}
</style>